module.exports = __webpack_public_path__ + "9ca356010afccc1946b8290847dc90bf.svg";